import React, { useEffect, useState, Fragment } from 'react';
import { Row, Col, message, Spin, Space, Button, Typography, Form, Table } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import FormGroup from 'Molecules/FormGroup';
import { useDispatch, useSelector } from 'react-redux';
import { getConversionItemList, patchConversionItemList } from '../../../../../ducks/actions'
import { editScItem, addScItem, removeScItem } from '../../../../../ducks/services'
import { Popup } from 'Atoms/Popup';
import { LoadingOutlined } from '@ant-design/icons';
import { useForm } from 'react-hook-form';
import Search from './Search'
import ActionButton from 'Molecules/ActionButton';
import { useTranslate } from 'Translate';

const _ = require('lodash');

const antIcon = <LoadingOutlined spin />;
const { Title } = Typography;

export default (props) => {
  const dispatch = useDispatch();
  const { id, activeTab, data, allowedEdit, allowedDelete, reloadCount } = props;
  const { control, formState: { errors }, handleSubmit, setValue, getValues, clearErrors } = useForm();
  const items = useSelector((state) => state.inventory.scItems);
  const meta = useSelector((state) => state.inventory.scItemsOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [load, setLoad] = useState(false);
  const [visible, setVisible] = useState(false);
  const [popVisible, setPopVisible] = useState(false);
  const [deets, setDeets] = useState();
  const [searchVal, setSearchVal] = useState();
  const editable = data?.status === "pending" && allowedEdit;
  const [selectedItem, setSelectedItem] = useState(null);
  const [orderTypeGroups, setOrderTypeGroups] = useState([]);
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("General.number_no"),
      dataIndex: 'index',
      key: 'index',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("General.item"),
      dataIndex: 'desc',
      key: 'desc',
      sorter: true,
      className: 'enable-click',
      render: (text, record) => <span>{record.code} {text}</span>
    },
    // {
    //   title: t("Delete.order_type"),
    //   dataIndex: 'order_type_group_desc',
    //   key: 'order_type_group_desc',
    //   sorter: true,
    //   className: 'enable-click',
    // },
    {
      title: t("Inventory.batch"),
      dataIndex: 'quantity',
      key: 'quantity',
      sorter: true,
      className: 'enable-click'
    },
    {
      title: t("System.reason"),
      dataIndex: 'reason_code',
      key: 'reason_code',
      sorter: true,
      className: 'enable-click',
      render: (text, record) => <span>{text} {record.reason_desc}</span>
    },
    {
      title: t("General.ings"),
      dataIndex: 'ingredients',
      key: 'ingredients',
      render: (text, record) => <Button type="link" className='px-0' onClick={() => { setPopVisible(true); setDeets({ label: `${record.code} ${record.desc}`, value: text}); }}>View</Button>
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="stock_conversion_item"
          btnAction1={editable ? () => {
            setVisible(true);
            setValue('id', record.id);
            setValue('item', record.product_id ? { label: `${record.code} ${record.desc}`, value: record.product_id } : '');
            setValue('quantity', record.quantity);
            setValue('reason', record.reason_id ? { label: `${record.reason_code} ${record.reason_desc}`, value: record.reason_id } : '');
            setSelectedItem(record.product_id);
            // let prod = meta?.products?.find(x => x.id === record.product_id);
            // setOrderTypeGroups(prod?.boms);
            // setValue('bom', record.bom_id ? { label: record.order_type_group_desc, value: record.bom_id } : "");
          } : false}
          onRemove={(data?.status === "pending" && allowedDelete) && onRemove}
          recordId={record.id}
          setLoading={setLoad}
          loading={load}
        />
    }
  ];

  const ingredientsCols = [
    {
      title: t("Delete.ingredient"),
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: t("General.uom"),
      dataIndex: 'uom',
      key: 'uom',
      align: 'center'
    },
    {
      title: t("General.qty"),
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (text) => <span>{parseFloat(text).toFixed(5)}</span>
    },
    {
      title: t("General.cost"),
      dataIndex: 'cost',
      key: 'cost',
      align: 'right',
      render: (text) => <span>{parseFloat(text || 0).toFixed(8)}</span>
    },
    {
      title: t("Inventory.unit_cost"),
      dataIndex: 'unit_cost',
      key: 'unit_cost',
      align: 'right',
      render: (text) => <span>{parseFloat(text).toFixed(8)}</span>
    }
  ]

  const formFields = [
    {
      name: 'id',
      label: '',
      type: 'input',
      hidden: true,
    },
    {
      name: 'item',
      label: t("General.item"),
      req: true,
      placeholder: t("General.please_select"),
      type: 'select',
      class: 'default-select',
      options: _.map(meta?.products, (e) => ({ label: `${e.code} ${e.name}`, value: e.id, product_uoms: e.product_uoms })),
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      onChange: (e) => {
        setSelectedItem(e.value);
        // let prod = meta?.products.find(x => x.id === e.value);
        // setOrderTypeGroups(prod?.boms);
      }
    },
    {
      name: 'quantity',
      label: t("Inventory.batch"),
      req: true,
      placeholder: t("General.please_select"),
      type: 'input',
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      allowNegDecNumNoZero: true
    },
    // {
    //   name: 'uom',
    //   label: t("General.uom"),
    //   req: true,
    //   placeholder: t("General.please_select"),
    //   type: 'select',
    //   class: 'default-select',
    //   options: orderTypeGroups?.map(x => ({ label: x.order_type_group_desc, value: x.id })),
    //   twocol: false,
    //   colWidth: '0 1 50%',
    //   reqmessage: t("General.required"),
    // },
    {
      name: 'reason',
      label: t("System.reason"),
      req: false,
      placeholder: t("General.please_select"),
      class: 'default-select',
      type: 'select',
      options: _.map(meta?.reasons, (e) => ({ label: `${e.code} ${e.desc}`, value: e.id })),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required")
    },
  ];

  useEffect(() => {
    if (activeTab === "2")
      dispatch(getConversionItemList(1, limit, '', '', null, setLoad, id));
  }, [activeTab]);

  const addNew = () => {
    setVisible(true);
    setValue('id', '');
    setValue('item', '');
    setValue('reason', '');
    setValue('quantity', '');
    setSelectedItem(null);
    setValue('bom', '');
    setOrderTypeGroups([]);
    clearErrors();
  }

  const btnList = [
    {
      text: `+ ${t("New.item")}`,
      classes: 'attendance-success',
      action: () => addNew(),
    }
  ];

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getConversionItemList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading, id));
    } else {
      dispatch(getConversionItemList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading, id));
    }
  }
  
  const onSearch = (search) => {
    setPage(1);
    if (search) {
      let searching = {};
      searching = {
        product_code: search?.product_code
      };
      setSearchVal(searching);
      dispatch(getConversionItemList(1, limit, '', '', searching, props.setLoading, id));
    } else {
      setSearchVal(null);
      dispatch(getConversionItemList(1, limit, '', '', null, props.setLoading, id));
    }
  };

  const onFinish = async (val) => {
    setLoad(true);

    const payload = {
      reason_id: val?.reason?.value,
      quantity: val?.quantity,
      product_id: val?.item?.value,
      stock_conversion_item_id: val?.id,
      stock_conversion_id: id,
      bom_id: val?.bom?.value,
    }
    await (val?.id ? editScItem : addScItem)(payload).then(res => {
      setLoad(false);
      if(res.data.code === 200) {
        message.success(t(`Success.sc_item_${val?.id ? "updated" : "added"}`));
        setVisible(false);
        setPage(1);
        reloadCount();
        // setTimeout(() => dispatch(getConversionItemList(1, limit, '', '', searchVal, props.setLoading, id)), 500);
        dispatch(patchConversionItemList(items, res.data.data, meta));
      }else {
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e?.message)
    })
  }

  const onRemove = async (recordId) => {
    setLoad(true);

    const payload = {
      stock_conversion_item_id: recordId,
      stock_conversion_id: id
    }
    await removeScItem(payload).then(res => {
      setLoad(false);
      if (res.data.code === 200) {
        message.success(t("Success.sc_item_removed"));
        setVisible(false);
        setPage(1);
        reloadCount();
        setTimeout(() => dispatch(getConversionItemList(1, limit, '', '', searchVal, props.setLoading, id)), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      setLoad(false);
      message.error(e?.message)
    })
  }

  const popup = {
    closable: false,
    visibility: visible,
    content: <Spin indicator={antIcon} size="large" spinning={load}>
      <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
        <Space direction='vertical' size={30} className='w-100'>
          <Title level={4} className='m-0'>
            {getValues('id') ? t("General.edit") : t("General.add")} {t("Inventory.sc_item")}
          </Title>
          <Row gutter={[10, 10]}>
            {formFields.map((item, idx) => (
              <Fragment key={idx}>
                <FormGroup item={item} control={control} errors={errors} />
              </Fragment>
            ))}
          </Row>
          <Row gutter={10} justify={'center'}>
            <Col span={12}><Button size='large' danger type="primary" className='w-100' onClick={() => {
              setVisible(false);
              setValue('id', '');
              setValue('item', '');
              setValue('reason', '');
              setValue('quantity', '');
              setSelectedItem(null);
              setValue('bom', '');
              setOrderTypeGroups([]);
              clearErrors();
            }}>{t("General.cancel")}</Button></Col>
            {
              editable &&
              <Col span={12}><Button size='large' type="primary" className='green-btn w-100' htmlType='submit'>{t("General.confirm")}</Button></Col>
            }
          </Row>
        </Space>
      </Form>
    </Spin>,
    width: 536,
    onCancel: () => {
      setVisible(false);
      setValue('id', '');
      setValue('reason', '');
      setValue('item', '');
      setValue('quantity', '');
      setSelectedItem(null);
      setValue('bom', '');
      setOrderTypeGroups([]);
      clearErrors();
    },
  };

  const popup2= {
    closable: true,
    visibility: popVisible,
    content:
      <>
        <Title className='mb-1' level={4}>
          {t("General.ings")} {`(${deets?.label})`}
        </Title>
        <Table
          scroll={500}
          dataSource={deets?.value?.map((x, idx) => ({ ...x, key: idx + 1 }))}
          columns={ingredientsCols}
          pagination={false}
        />
      </>
    , // <pre style={{ whiteSpace: "break-spaces" }}><code>{JSON.stringify(deets, null, 2)}</code></pre>, // list in table instead, <Table> and loop the deets
    width: 1000,
    onCancel: () => {
      setPopVisible(false);
    },
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click") && editable){
          setValue('id', record.id);
          setValue('item', record.product_id ? { label: `${record.code} ${record.desc}`, value: record.product_id } : '');
          setValue('quantity', record.quantity);
          setValue('reason', record.reason_id ? { label: `${record.reason_code} ${record.reason_desc}`, value: record.reason_id } : '');
          setSelectedItem(record.product_id);
          // let prod = meta?.products?.find(x => x.id === record.product_id);
          // setOrderTypeGroups(prod?.boms);
          // setValue('bom', record.bom_id ? { label: record.order_type_group_desc, value: record.bom_id } : "");
          setVisible(true);
          clearErrors();
        }
      },
    };
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={load}>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={''} btnList={editable ? btnList : []} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            onSearch={onSearch}
            Search={Search}
            onRow={onClickRow}
            ListData={items?.list?.map((x, idx) => ({ ...x, key: x.id, index: idx + 1}))}
            onChange={onTableChange}
            ListCol={colName}
            pagination={{
              total: items?.total_count,
              current: page,
              pageSize: limit
            }}
          />
        </Col>
      </Row>
      <Popup {...popup} />
      <Popup {...popup2} />
    </Spin>
  )
}